import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import TableCell from 'src/components/Table/TableCell';
import { useTranslation } from 'react-i18next';
import TablePaginationCustom from 'src/components/Table/TablePaginationCustom';
import Table from 'src/components/Table';
import CounselorsRow from './CounselorsRow';

if (!process.env.REACT_APP_TABLE_SIZE) {
  console.error(
    'REACT_APP_TABLE_SIZE variable not loaded properly. Check your .env file please!'
  );
}

const Tbody = ({ counselors }) =>
  counselors.map(counselor => (
    <CounselorsRow key={counselor.id} {...counselor} />
  ));

const CounselorsTable = ({
  className,
  counselors,
  count,
  page,
  handleChangePage,
  loading,
  ...rest
}) => {
  const { t } = useTranslation();

  const theads = useMemo(
    () => () => (
      <TableRow>
        <TableCell variant="head" key="id" align="center" sx={{ width: '5%' }}>
          {t('COMMON.ID')}
        </TableCell>

        <TableCell variant="head" key="fullName" align="center">
          {t('COMMON.FULL_NAME')}
        </TableCell>
        <TableCell variant="head" key="fullName" align="center">
          {t('COMMON.EMAIL')}
        </TableCell>
        <TableCell variant="head" key="fullName" align="center">
          {t('COMMON.PHONE')}
        </TableCell>
        <TableCell variant="head" key="fullName" align="center">
          {t('COUNSELORS.IS_SIGNATORY')}
        </TableCell>

        <TableCell variant="head" key="actions" align="center">
          {' '}
        </TableCell>
      </TableRow>
    ),
    [t]
  );

  const tbody = useMemo(() => () => <Tbody counselors={counselors} />, [
    counselors
  ]);

  const pagination = useMemo(
    () => () => (
      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={count}
        rowsPerPage={+process.env.REACT_APP_TABLE_SIZE}
        page={page}
        onPageChange={handleChangePage}
        ActionsComponent={TablePaginationCustom}
        labelDisplayedRows={({ from, to, count: c }) => {
          return `${from}-${to} ${t('COMMON.OF')} ${c}`;
        }}
      />
    ),
    [page, counselors]
  );

  return (
    <Table
      {...rest}
      variant="outlined"
      tbody={tbody}
      theads={theads}
      pagination={pagination}
      loading={loading}
    />
  );
};

CounselorsTable.propTypes = {
  className: PropTypes.string,
  counselors: PropTypes.array.isRequired,
  count: PropTypes.number,
  page: PropTypes.number,
  handleChangePage: PropTypes.func,
  handleSortChange: PropTypes.func,
  loading: PropTypes.bool
};

CounselorsTable.defaultProps = {
  count: 0
};

export default CounselorsTable;
